/*
 * @Descripttion: 
 * @version: 
 * @Author: somebody
 * @Date: 2019-11-21 14:58:04
 * @LastEditors: hanzb
 * @LastEditTime: 2020-04-02 14:22:24
 */
import { sgiLogger } from "../sgiCommon/sgiLogger";

/**
 * @namespace 组件管理器
 */
let ComponentManager = {
	/**
	 * 组件缓存
	 */
	all: {},
	/**
	 * 获取组件实例
	 * @param {string} uid 页面guid
	 * @param {string} id 组件id
	 */
	get: function (uid, id) {
		if (!uid || !id) {
			return null;
		}
		let uidCompMng = this.all[uid];
		if (!uidCompMng) {
			return null;
		}
		let comp = uidCompMng[id];
		if (!comp) sgiLogger.debug(`组件管理器中找不到key为${id}的组件，在guid为${uid}的页面下。建议检查代码确认该情况是否正常！`);
		return comp;
	},
	/**
	 * 设置控件实例
	 * @param {string} uid 页面guid
	 * @param {string} id 控件id
	 * @param {instance} component 控件实例
	 */
	set: function (uid, id, component) {
		if (!uid || !id || !component) {
			return null;
		}
		let uidCompMng = this.all[uid];
		if (!uidCompMng) {
			uidCompMng = {};
			this.all[uid] = uidCompMng;
		}
		uidCompMng[id] = component;
	},
	/**
	 * 删除指定页面下所有控件实例缓存
	 * @param {string} uid 页面guid
	 */
	deleteByUid: function (uid) {
		if (!uid) return;
		delete this.all[uid];
	},
	/**
	 * 删除指定页面下指定控件缓存
	 * @param {string} uid 页面guid
	 * @param {string} id 控件id
	 */
	deleteById: function (uid, id) {
		if (!uid || !id) return;

		let uidCompMng = this.all[uid];
		if (!uidCompMng) return;

		delete uidCompMng[id];
	},
}

// 初始化
if (!window.ComponentManager) window.ComponentManager = ComponentManager;
// 添加方法
else Object.assign(window.ComponentManager, ComponentManager);
// 导出
let wComponentManager = window.ComponentManager;
export { wComponentManager as ComponentManager };
export default wComponentManager;


// WEBPACK FOOTER //
// ./~/rt-sd-common/sgiFactory/ComponentManager.js